<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()

  import congrats from "@images/courses/congrats.jpg"
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl font-bold">Module 9: Plan Wrap-Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Congratulations on getting to the final module of this course. This
      learning module is focused on giving you everything you need to put the
      final touches on your One Page Alignment Plan.
    </p>

    <p class="mt-6 text-lg">
      This module I will take you through a review of your One Page Alignment
      Plan, give you direction on how to get your team involved, and take you
      through the process for selecting images. I will share with you the steps
      you can follow to roll the plan out to everyone in your company.
    </p>
    <p class="mt-6 text-lg">
      I will close this module's class by sharing with you the resources you
      have available to you to help you bring the plan to life on a daily basis
      and execute with discipline. This includes the next level of classes in
      The Lead With Purpose University along with our Coaching and
      Accountability programs.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832871"
        class="absolute inset-0 w-full h-full"
        id="video"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        title="Course Video"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-2xl font-bold">9.2 Your Plan Review</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I share with you a set of questions you can use to make
      each of the seven components of your One Page Alignment Plan as strong as
      possible. I recommend that as you go through this module, you have your
      One Page Alignment Plan open online along with a printed hardcopy at your
      side.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832874"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-2xl font-bold">9.3 Selecting Images</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I walk you through the process you and your employees will go through to
      select images for your plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832886"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-2xl font-bold">9.4 Connect Everyone</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you the process for rolling out your plan to your entire
      company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832889"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-2xl font-bold">9.5 Additional Courses</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I share with you all of the courses from the Lead With
      Purpose University you are now eligible to enroll in and which will help
      you to execute with discipline. The courses you have not yet completed are
      listed below.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832898"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-2xl font-bold">9.6 Coaching & Accountability</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Watch this video to learn about the Coaching and Accountability Program we
      offer at Lead With Purpose to help you reach your full leadership
      potential and keep your team aligned, laser focused, and accountable to
      the goals on the plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832904"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-2xl font-bold">9.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon this wrap up module.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832927"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 8}
  <div class="px-6 pb-12">
    <img
      src={congrats}
      class="mt-8 max-w-3xl mx-auto rounded-t-lg"
      alt="Congratulations"
    />
    <div class="max-w-3xl mx-auto">
      <p class="text-xl bg-blue-900 text-white rounded-b-lg shadow p-8">
        You have now completed the E1: One-Page Alignment Plan Course! Now is a
        great time to check out the other courses Lead With Purpose University
        has available and continue to develop Fast Attack Leaders at your
        company.
      </p>
    </div>
  </div>
{/if}
